module.exports = __webpack_public_path__ + "img/fwdDownOff.2af5905e.svg";